import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSmoothScroll } from "./lib/smoothScroll";

// Apply custom styles for the font families
const customStyles = `
  :root {
    --font-montserrat: 'Montserrat', sans-serif;
    --font-opensans: 'Open Sans', sans-serif;
    
    /* Custom Colors */
    --accent: 194, 94%, 69%;  /* Cyan #62D5FA - matches global-cyan */
    --accent-light: 194, 94%, 84%;  /* Light Cyan */
    
    /* Override default styles to match design reference */
    --background: 0 0% 100%;
    --foreground: 0 0% 20%;
    --card: 0 0% 100%;
    --card-foreground: 0 0% 20%;
    --popover: 0 0% 100%;
    --popover-foreground: 0 0% 20%;
    --primary: 0 0% 0%;
    --primary-foreground: 0 0% 100%;
    --secondary: 0 0% 96%;
    --secondary-foreground: 0 0% 20%;
    --muted: 0 0% 96%;
    --muted-foreground: 0 0% 45%;
    --border: 0 0% 92%;
    --input: 0 0% 86%;
    --ring: var(--accent);
    
    /* Hero Gradient */
    --hero-gradient-start: rgba(0, 0, 0, 0.5);
    --hero-gradient-end: rgba(0, 0, 0, 0.7);
  }
`;

// Insert the custom styles
const styleElement = document.createElement("style");
styleElement.innerHTML = customStyles;
document.head.appendChild(styleElement);

// Initialize Lenis smooth scrolling and store globally
declare global {
  interface Window {
    lenis?: any;
  }
}

// Only initialize Lenis if not on a CRM page
const currentPath = window.location.pathname;
if (!currentPath.startsWith('/crm')) {
  window.lenis = initSmoothScroll();
}

createRoot(document.getElementById("root")!).render(<App />);
